
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';

const TRACKER_WIDTH = 45;

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    numberOfParts: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      sizeOfParts: this.numberOfParts,
    };
  },
  computed: {
    leftMargin(): Number {
      return -(this.progress * TRACKER_WIDTH) / 100;
    },
  },
});
